import { render, staticRenderFns } from "./TeamPanel.vue?vue&type=template&id=2a506ffd&scoped=true&"
import script from "./TeamPanel.vue?vue&type=script&lang=js&"
export * from "./TeamPanel.vue?vue&type=script&lang=js&"
import style0 from "./TeamPanel.vue?vue&type=style&index=0&id=2a506ffd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a506ffd",
  null
  
)

export default component.exports